import { useCallback, useState } from 'react';

export interface SectionHeight {
  height: number;
  sectionId: number;
}

export const useSectionHeights = () => {
  const [sectionHeights, setSectionHeights] = useState<Map<number, number>>(new Map());

  const updateSectionHeight = useCallback((sectionId: number, height: number) => {
    setSectionHeights(prev => {
      const newMap = new Map(prev);
      newMap.set(sectionId, height);
      return newMap;
    });
  }, []);

  const getSectionHeight = useCallback(
    (sectionId: number): number => {
      return sectionHeights.get(sectionId) || 97.06; // Default to SWIMLANE_MIN_HEIGHT if not set
    },
    [sectionHeights]
  );

  return {
    sectionHeights,
    updateSectionHeight,
    getSectionHeight,
  };
};
